export default [
	...middleware('guest', [
		{
			path: '/',
			name: 'Login',
			component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
		}
	]),
	...middleware('auth', [
		{
			path: '/',
			name: 'Auth',
			component: () => import(/* webpackChunkName: "auth" */ '../views/auth/Auth.vue'),
			children: [
				{
					path: 'songs',
					name: 'SongsList',
					component: () => import(/* webpackChunkName: "songs" */ '../views/auth/SongsList.vue')
				},
				{
					path: 'songs/new-music',
					name: 'CreateMusic',
					component: () => import(/* webpackChunkName: "create-music" */ '../views/auth/CreateMusic.vue')
				},
				{
					path: 'subscribers',
					name: 'SubscribersList',
					component: () => import(/* webpackChunkName: "subscriber" */ '../views/auth/SubscribersList.vue')
				},
				{
					path: 'subscriptions',
					name: 'SubscriptionsList',
					component: () => import(/* webpackChunkName: "Subscriptions" */ '../views/auth/SubscriptionsList.vue')
				},
				{
					path: 'binding-accounts',
					name: 'BindingAccountsList',
					component: () => import(/* webpackChunkName: "Subscriptions" */ '../views/auth/BindingAccountsList.vue')
				},
				{
					path: 'subscriber-plans',
					name: 'SubscriberPlansList',
					component: () => import(/* webpackChunkName: "Subscriptions" */ '../views/auth/SubscriberPlansList.vue')
				},
				{
					path: 'subscriber-plans/create',
					name: 'SubscriberPlansCreate',
					component: () => import(/* webpackChunkName: "Subscriptions" */ '../views/auth/SubscriberPlansCreate.vue')
				},
				{
					path: 'subscriber-plans/edit/:id',
					name: 'SubscriberPlansEdit',
					component: () => import(/* webpackChunkName: "SubscriptionsEdit" */ '../views/auth/SubscriberPlansEdit.vue'),
					props: true
				},
				{
					path: 'themes',
					name: 'ThemesList',
					component: () => import(/* webpackChunkName: "themes" */ '../views/auth/ThemesList.vue')
				}
			]
		}
	])
]

function middleware (middleware, routes) {
	routes.forEach(route =>
		(route.middleware || (route.middleware = [])).unshift(middleware)
	)

	return routes
}
